<template>
  <multi-select
      :value="usersGroups"
      :multiple="true"
      label="name"
      track-by="id"
      :placeholder="placeholderCopy"
      :options="filteredGroups"
      :close-on-select="false"
      :data-ec="dataEc"
      data-et="teams_input"
      @input="$emit('input', $event)"
      @select="$emit('select', $event)"
      @remove="$emit('remove', $event)"
      :disabled="disabled"
  >
    <template slot="tag" slot-scope="props">
        <span class="multiselect__tag"><span>{{ props.option.name }}</span>
          <i aria-hidden="true" tabindex="0" class="multiselect__tag-icon" @keypress.enter.prevent="props.remove(props.option)" @click="props.remove(props.option)"></i>
        </span>
    </template>
    <template slot="noOptions">
      {{ $t('multiselect.noTeamsFound') }}
    </template>
  </multi-select>
</template>

<script>
import { cloneDeep } from 'lodash';
import MultiSelect from '@/components/MultiSelect.vue';

export default {
  name: 'UserTeamSelector',

  components: {
    MultiSelect,
  },

  props: {
    usersGroups: {
      type: Array,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
    dataEc: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    placeholderCopy() {
      return this.usersGroups.length > 0
          ? this.$t('users.add-to-another-team')
          : this.$t('users.start-typing-a-teams-name');
    },
    filteredGroups() {
      const groups = cloneDeep(this.groups);

      return groups.map((group) => {
        const g = group;

        if (this.usersGroups.filter(userGroup => userGroup.id === group.id).length > 0) {
          g.$isDisabled = true;
        }
        return g;
      });
    },
  },
};
</script>

<style scoped>

</style>
